import { KLARO_FEATURES } from './klaroFeatures';

export const DASHBOARD_CARD_DEFINITIONS = KLARO_FEATURES.filter((feature) => feature.dashboard).map((feature) => ({
  id: feature.id,
  title: feature.title,
  description: feature.description,
  route: feature.route,
  icon: feature.icon,
  defaultVisible: feature.defaultVisible,
  feature: feature.feature,
  mobileWide: Boolean(feature.mobileWide),
}));

export const DEFAULT_DASHBOARD_CARDS = DASHBOARD_CARD_DEFINITIONS.map(({ id, defaultVisible }) => ({ id, visible: defaultVisible }));

export function normalizeDashboardCards(value) {
  const configured = Array.isArray(value) ? value : [];
  const knownIds = new Set(DASHBOARD_CARD_DEFINITIONS.map((card) => card.id));
  const seen = new Set();
  const normalized = [];
  configured.forEach((item) => {
    if (!item || !knownIds.has(item.id) || seen.has(item.id)) return;
    seen.add(item.id);
    normalized.push({ id: item.id, visible: item.visible !== false });
  });
  DEFAULT_DASHBOARD_CARDS.forEach((item) => { if (!seen.has(item.id)) normalized.push({ ...item }); });
  return normalized;
}

export function getVisibleDashboardCards(value, hasFeature = () => true) {
  const definitions = Object.fromEntries(DASHBOARD_CARD_DEFINITIONS.map((card) => [card.id, card]));
  const eligible = normalizeDashboardCards(value)
    .map((item) => ({ ...item, card: definitions[item.id] }))
    .filter(({ card }) => card && hasFeature(card.feature));
  const visible = eligible.filter((item) => item.visible).map((item) => item.card);
  if (visible.length > 0) return visible;

  const defaults = eligible.filter(({ card }) => card.defaultVisible).map(({ card }) => card);
  return defaults.length > 0 ? defaults : eligible.slice(0, 1).map(({ card }) => card);
}
